import type { PickerProps } from './types';

const OPTIONS = ['DENY', 'SAMEORIGIN'];

export function XFrameOptionsPicker({ value, onChange }: PickerProps) {
  const current = value.trim().toUpperCase();
  return (
    <div className="picker-row">
      {OPTIONS.map((opt) => (
        <button
          key={opt}
          className={current === opt ? 'pill active' : 'pill'}
          onClick={() => onChange(opt)}
          type="button"
        >
          {opt}
        </button>
      ))}
    </div>
  );
}
